export default function setAdressFieldsForCurrentUser({ state }) {
  let { registrating, currentUser, addresstypes } = state.get('client')
  if (currentUser) {
    let current = registrating.current
    addresstypes.forEach(addressType => {
      let currentClientAddressTypes = currentUser.currentClient[addressType]
      if (current[addressType] && currentClientAddressTypes) {
        Object.keys(
          currentClientAddressTypes
        ).forEach(currentClientAddressType => {
          let statePath = `client.registrating.current.${addressType}.${currentClientAddressType}`
          let data = currentClientAddressTypes[currentClientAddressType]
          let addressFieldInState =
            current[addressType][currentClientAddressType]
          if (addressFieldInState) {
            let newData = null
            if (Array.isArray(data) && addressFieldInState.options) {
              newData = addressFieldInState.options.reduce((acc, item) => {
                if (data.indexOf(item.key) > -1) {
                  const { key, value, index } = item
                  state.merge(`${statePath}.options.${index}`, {
                    selected: true
                  })
                  acc.push({ key, value, index })
                }
                return acc
              }, [])
            } else {
              newData = data
            }
            state.set(`${statePath}.value`, newData)
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/setAddressFieldsForCurrentUser.js